import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <motion.span
    className={`reveal-line ${className}`}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-8%" }}
  >
    <motion.span
      variants={{ hidden: { y: "110%" }, show: { y: 0 } }}
      transition={{ duration: 1, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </motion.span>
);

export const FadeUp = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-6%" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Kicker = ({ children, className = "" }) => (
  <p className={`font-accent text-xs uppercase tracking-[0.25em] text-terra ${className}`}>{children}</p>
);
